import { request } from '../../services';
import { createActions } from 'redux-actions';

const { bulkProjectLoadSuccess, bulkProjectLoadFailure, bulkProjectLoadRequest } =
  createActions(
    'BULK_PROJECT_LOAD_SUCCESS',
    'BULK_PROJECT_LOAD_REQUEST',
    'BULK_PROJECT_LOAD_FAILURE',
  );

export const requestbulkProjectLoad = projects => (dispatch) => {
  dispatch(bulkProjectLoadRequest());
  return request('projects', { method: 'POST', body: { projects } })
    .then(() => dispatch(bulkProjectLoadSuccess()))
    .catch(error => dispatch(bulkProjectLoadFailure(error)));
};



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/projects.js